import EsusView from 'components/esus/EsusView'

export default function FichaAtendimentoOdontologicoView() {
  return <EsusView url='/pec/user/cds/atendimentoOdontologico' />
}
